var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckboxCheckPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icons8-tick-box",
    fill: "#2e2d79",
    d: "M5 2a3.015 3.015 0 0 0-3 3v14a3.015 3.015 0 0 0 3 3h14a3.015 3.015 0 0 0 3-3v-8h-2v8a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h9V2zm15.473 1.914l-9.293 9.852-3.672-3.672-1.414 1.414 5.127 5.127L21.928 5.287z",
    transform: "translate(-2 -2)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxCheckPurple);
export default __webpack_public_path__ + "static/media/checkbox-check-purple.2ff5964a0dd69d71ac3d374e804d401c.svg";
export { ForwardRef as ReactComponent };